import {getColumnData, getServerData} from '@/api'
import uCharts from '@qiun/ucharts';
import performanceIconImg1 from '@/assets/images/performance/1.png'
import performanceIconImg2 from '@/assets/images/performance/2.png'
import performanceIconImg3 from '@/assets/images/performance/3.png'
import performanceIconImg4 from '@/assets/images/performance/4.png'
import performanceIconImg5 from '@/assets/images/performance/5.png'
function getH5Offset(e) {
    e.mp = {
        changedTouches: []
    };
    e.mp.changedTouches.push({
        x: e.offsetX,
        y: e.offsetY
    });
    return e;
}
var uChartsInstance = {};
export default {
    data() {
        return {
            sysName:"",
            total_amount:0.00,
            doc_amount:0.00,
            order_count:0,
            userInfo: null,
            searchParams: null,
            patientlist: [],
            actDate: "0",
            minTime: null,
            maxTime: null,
            range: [],
            medTop10Data: {}, // 药品使用TOP10
            columnData: {}, // 诊疗情况
            columnTitle: "近七日诊疗情况",
            performanceIcon1: performanceIconImg1,
            performanceIcon2: performanceIconImg2,
            performanceIcon3: performanceIconImg3,
            performanceIcon4: performanceIconImg4,
            performanceIcon5: performanceIconImg5,

            columnWidth: 750,
            columnHeight: 500,
        }
    },
    mounted() {
        let nowDate = this.getDateVal("1");
        this.columnTitle = "近七日诊疗情况";
        this.range = [];
        let before7Date = this.getDateVal("0");
        console.log(before7Date);
        this.range.push(before7Date);
        this.range.push(nowDate);
        this.actDate = "0";

        this.columnWidth = this.$refs.columnChartCon.clientWidth - 40;
        this.columnHeight = this.$refs.columnChartCon.clientHeight - 40;
        // console.log(this.$refs.columnChartCon.clientWidth);
        // console.log(this.$refs.columnChartCon.clientHeight);

        setTimeout(()=>{
            this.queryData(); // 查询
        }, 200)

    },
    created() {
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 选日期
        chooseDate() {
            let nowDate = this.getDateVal("1");
            if (this.actDate === '0') {
                this.columnTitle = "近七日诊疗情况";
                this.range = [];
                let before7Date = this.getDateVal("0");
                // console.log("before7Date >>>>" + before7Date);
                this.range.push(before7Date);
                this.range.push(nowDate);
            } else if (this.actDate === '1') {
                this.columnTitle = "今日诊疗情况";
                this.range = [];
                this.range.push(nowDate);
                this.range.push(nowDate);
            } else if (this.actDate === '2') {
                this.columnTitle = "昨日诊疗情况";
                this.range = [];
                let before1Date = this.getDateVal("2");
                this.range.push(before1Date);
                this.range.push(before1Date);
            } else if (this.actDate === '3') {
                this.columnTitle = "近30天诊疗情况";
                this.range = [];
                let before30Date = this.getDateVal("3");
                this.range.push(before30Date);
                this.range.push(nowDate);
            }
            this.queryData(); // 查询
        },




        // 查询
        queryData() {
            // console.log(this.range)
            this.getServerChartsData(); // 费用占比
            this.getColumnChartsData(); // 近七日诊疗情况
        },

        // 重置
        resetQuery() {
            let nowDate = this.getDateVal("1");
            this.columnTitle = "近七日诊疗情况";
            this.range = [];
            let before7Date = this.getDateVal("0");
            console.log(before7Date);
            this.range.push(before7Date);
            this.range.push(nowDate);
            this.actDate = "0";
            this.queryData(); // 查询
        },


        // 近七日诊疗情况 这个查询比较耗时 另外一个查成功才会查这个
        getColumnChartsData() {
            //模拟从服务器获取数据时的延时
            getColumnData(this.range[0],this.range[1]).then(response => {
                // console.log(response);
                let rdata = response.data.data;
                // 仅展示 总额度（药费+病程管理费） 与 挂号费 两条曲线，其余序列不展示
                let docData = [], medData = [], adjData = [];
                (rdata.series || []).forEach(s => {
                    if (s.name === '诊费') docData = s.data;
                    else if (s.name === '药费') medData = s.data;
                    else if (s.name === '调理费用') adjData = s.data;
                });
                let totalData = medData.map((v, i) => Number(v || 0) + Number(adjData[i] || 0));
                let res = {
                    categories: rdata.categories,
                    series: [{
                        name: "总额度",
                        data: totalData
                    }, {
                        name: "挂号费",
                        data: docData
                    }]
                };
                this.drawCharts('columnChartContainer', res);
            });
        },

        drawCharts(id,data){
            const ctx = document.getElementById(id).getContext("2d");
            uChartsInstance[id] = new uCharts({
                type: "line",
                context: ctx,
                width: this.columnWidth,
                height: this.columnHeight,
                categories: data.categories,
                series: data.series,
                animation: true,
                background: "#FFFFFF",
                color: ["#1890FF","#91CB74","#FAC858","#EE6666","#73C0DE","#3CA272","#FC8452","#9A60B4","#ea7ccc"],
                padding: [15, 15, 0, 5],
                dataLabel: false,
                dataPointShape: false,
                enableScroll: false,
                legend: {
                    show: true,
                    position: "top",
                    lineHeight: 32
                },
                xAxis: {
                    disableGrid: true
                },
                yAxis: {
                    gridType: "dash",
                    dashLength: 2,
                    data: [
                        {
                            min: 0,
                            max: 150
                        }
                    ]
                },
                extra: {
                    line: {
                        type: "curve",
                        width: 2,
                        activeType: "hollow",
                        linearType: "custom"
                    }
                }
            });
        },

        // 费用数据（费用占比饼图已下线，仅保留接口取数）
        getServerChartsData() {
            getServerData(this.range[0],this.range[1]).then(response => {
                let rdata = response.data.data;
                // 门诊端「总额度」= 药品费用 + 病程管理费（medical_adjust_total）
                this.total_amount = rdata.medical_adjust_total;
                // 挂号费卡片取预约挂号费（reservation_fee_total）；doc_price_total 是诊金，不是挂号费
                this.doc_amount = rdata.reservation_fee_total;
                this.order_count = Number(rdata.order_count_total) || 0;
            });

        },


        tap(e){
            uChartsInstance[e.target.id].touchLegend(getH5Offset(e));
            uChartsInstance[e.target.id].showToolTip(getH5Offset(e));
        },

        // 获取日期
        getDateVal(type) {
            let currentDate = new Date();
            if (type === "0") {
                // 获取七天前的日期
                currentDate.setDate(currentDate.getDate() - 7);
            } else if (type === "1") {
                // 获取今天天的日期
                currentDate.setDate(currentDate.getDate());
            } else if (type === "2") {
                // 获取前一天的日期
                currentDate.setDate(currentDate.getDate() - 1);
            } else if (type === "3") {
                // 获取30天前的日期
                currentDate.setDate(currentDate.getDate() - 30);
            } else if (type === "4") {
                // 获取90天前的日期
                currentDate.setDate(currentDate.getDate() - 90);
            }
            // 格式化日期
            let year = currentDate.getFullYear();
            let month = currentDate.getMonth() + 1;
            let monthVal = month > 9 ? month : "0" + month;
            let day = currentDate.getDate();
            let dayVal = day > 9 ? day : "0" + day;

            return year + '-' + monthVal + '-' + dayVal;
        },

    }
}